import moment from 'moment';
import isPlainObject from 'lodash/isPlainObject';
import isString from 'lodash/isString';
import isFunction from 'lodash/isFunction';
import capitalize from 'lodash/capitalize';
import get from 'lodash/get';
import {
  appRoutes,
  DATE_FORMAT_INPUT,
  otherOption,
  userRoles
} from './constants';

export const failedAndSucceededNotIncluded = {
  failed: { include: false },
  succeeded: { include: false }
};

export const failedNotIncluded = {
  failed: { include: false }
};

export const succeededNotIncluded = {
  succeeded: { include: false }
};

export const alertCreator = (meta) => {
  if (isPlainObject(meta) && isPlainObject(meta.alert) && isString(meta.alert.message)) {
    const { alert } = meta;
    const validTypes = {
      danger: 'Alerta',
      success: 'Confirmación',
      warning: 'Aviso'
    };
    alert.headline = validTypes[alert.type];
    if (Object.keys(validTypes).indexOf(alert.type) < 0) {
      alert.headline = validTypes.danger;
      alert.type = 'danger';
    }
    return { alert };
  }
};

export const objectValues = obj => Object.keys(obj).map(key => obj[key]);

export const optionsCreator = (options = {}) => (
  objectValues(options).map(({ value, label }) => ({
    id: value,
    label: capitalize(label),
    value
  }))
);

export const mapOptions = options => (
  options.map(({ id: value, name: label = '' }) => ({
    label,
    value
  }))
);

export const mapAccessor = (accessor = '', defaultValue = '') => original => get(original, accessor, defaultValue);

export const flatten = (arrayToFlatten = [], initialValue = []) => (
  arrayToFlatten.reduce((a, b) => a.concat(b), initialValue)
);

export const fieldParser = (parser = Number, defaultValue = null) => (value) => {
  if (isFunction(parser) && value !== '') {
    if (value === otherOption.id) {
      return value;
    }
    return parser(value);
  }
  return defaultValue;
};

export const htmlInnerText = (htmlString) => {
  const testDiv = document.createElement('div');
  testDiv.innerHTML = htmlString;
  return testDiv.innerText;
};

export const filterDatesAfterToday = date => date.isBefore();

export const isValidDate = (date, dateFormat = DATE_FORMAT_INPUT) => (
  moment(date, dateFormat, true).isValid()
);

export const getUserHomePage = (userRole = {}) => {
  switch (userRole.id) {
    case userRoles.superAdmin.value:
    case userRoles.admin.value:
    case userRoles.client.value:
      return appRoutes.dashboard.index;
    case userRoles.technician.value:
      return appRoutes.technicians.index;
    default:
      return '/';
  }
};



// WEBPACK FOOTER //
// ./src/shared/utils.js